var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "company-map ml-4 mr-4" },
    [
      _vm.type === "create"
        ? _c(
            "div",
            [
              _c("div", { staticClass: "row py-3 align-items-center" }, [
                _c("div", { staticClass: "col company-h1" }, [
                  _c("button", {
                    staticClass: "btn btn-back",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.setCompanyStep("companies-info")
                      }
                    }
                  }),
                  _vm._v("\n        Create Company\n      ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col text-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary ld-ext-right",
                      class: _vm.loadingButton ? "running" : "",
                      attrs: { type: "button", disabled: _vm.buttonDisabled }
                    },
                    [
                      _vm._v("\n          Save\n          "),
                      _c("div", { staticClass: "ld ld-ball ld-flip" })
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("companies-steps-menu", { attrs: { type: "create" } })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "edit"
        ? _c("div", [
            _c(
              "div",
              { staticClass: "row py-3 align-items-center company-header" },
              [
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("h2", { staticClass: "company-h1 mr-3" }, [
                      _c("button", {
                        staticClass: "btn btn-back",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.$router.push("/companies")
                          }
                        }
                      }),
                      _vm._v(
                        "\n          " + _vm._s(_vm.company.name) + "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.company.status
                      ? [
                          _vm.company.status.name === "Active"
                            ? _c("span", { class: "btn-status btn-active" }, [
                                _vm._v(_vm._s(_vm.company.status.name))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.company.status.name === "Inactive"
                            ? _c("span", { class: "btn-status btn-closed" }, [
                                _vm._v(_vm._s(_vm.company.status.name))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.company.status.name === "Setup Incomplete"
                            ? _c(
                                "span",
                                { class: "btn-status btn-ncover info-company" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.company.status.name) +
                                      "\n            "
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "btn btn-link p-0 tippy-popup tippy-info",
                                      on: {
                                        mouseover: function($event) {
                                          _vm.showTooltipPrefix = true
                                        },
                                        mouseout: function($event) {
                                          _vm.showTooltipPrefix = false
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-info-circle"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.showTooltipPrefix
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "popover tippy-info-popover"
                                        },
                                        [
                                          _vm._v(
                                            "\n              Setup incomplete is present when the company doesn't have one or more of the following: move sizes, arrival windows, merchant account, rates and coverage.\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-8 d-flex align-items-center justify-content-end"
                  },
                  [
                    _vm.$_can("companies.review.request")
                      ? _c("companies-visibility-bar", {
                          attrs: { company: _vm.company },
                          on: {
                            saved: function($event) {
                              _vm.$emit("saved")
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary ld-ext-right ml-5",
                        class: _vm.loadingButton ? "running" : "",
                        attrs: { type: "button", disabled: _vm.buttonDisabled }
                      },
                      [
                        _vm._v("\n          Save\n          "),
                        _c("div", { staticClass: "ld ld-ball ld-flip" })
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("p", { staticClass: "mt-3 submit-text" }, [
        _vm._v(
          "To get started with our online services please submit the request below after you've completed the checklist! Ensure you've filled in the request details."
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "request-checklist" }, [
        _c("p", { staticClass: "request-checklist-title" }, [
          _vm._v("Visibility request checklist")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "request-checklist-items" }, [
          _c("div", { staticClass: "request-checklist-item rounded-top" }, [
            _c(
              "span",
              {
                class: {
                  "request-checklist-item-checkbox-active":
                    _vm.checkList.licence_number,
                  "request-checklist-item-checkbox": !_vm.checkList
                    .licence_number
                }
              },
              [
                _c("span", {
                  staticClass: "mod-icon-check",
                  staticStyle: { width: "10px", height: "10px" }
                })
              ]
            ),
            _vm._v(" "),
            _c("label", [
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "/companies/edit/" +
                      _vm.$route.params.id +
                      "?tab=companies-licence"
                  }
                },
                [_vm._v("Company licence")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "request-checklist-item" }, [
            _c(
              "span",
              {
                class: {
                  "request-checklist-item-checkbox-active":
                    _vm.checkList.request_note,
                  "request-checklist-item-checkbox": !_vm.checkList.request_note
                }
              },
              [
                _c("span", {
                  staticClass: "mod-icon-check",
                  staticStyle: { width: "10px", height: "10px" }
                })
              ]
            ),
            _vm._v(" "),
            _c("label", [
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "/companies/edit/" +
                      _vm.$route.params.id +
                      "?tab=companies-licence"
                  }
                },
                [
                  _vm._v("Visibility request note "),
                  _c("i", [_vm._v("(optional)")])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "request-checklist-item" }, [
            _c(
              "span",
              {
                class: {
                  "request-checklist-item-checkbox-active": _vm.checkList.logo,
                  "request-checklist-item-checkbox": !_vm.checkList.logo
                }
              },
              [
                _c("span", {
                  staticClass: "mod-icon-check",
                  staticStyle: { width: "10px", height: "10px" }
                })
              ]
            ),
            _vm._v(" "),
            _c("label", [
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "/companies/edit/" +
                      _vm.$route.params.id +
                      "?tab=website-details"
                  }
                },
                [_vm._v("Logo")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "request-checklist-item" }, [
            _c(
              "span",
              {
                class: {
                  "request-checklist-item-checkbox-active":
                    _vm.checkList.company_description,
                  "request-checklist-item-checkbox": !_vm.checkList
                    .company_description
                }
              },
              [
                _c("span", {
                  staticClass: "mod-icon-check",
                  staticStyle: { width: "10px", height: "10px" }
                })
              ]
            ),
            _vm._v(" "),
            _c("label", [
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "/companies/edit/" +
                      _vm.$route.params.id +
                      "?tab=website-details"
                  }
                },
                [_vm._v("Company description")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "request-checklist-item" }, [
            _c(
              "span",
              {
                class: {
                  "request-checklist-item-checkbox-active":
                    _vm.checkList.gallery_of_images,
                  "request-checklist-item-checkbox": !_vm.checkList
                    .gallery_of_images
                }
              },
              [
                _c("span", {
                  staticClass: "mod-icon-check",
                  staticStyle: { width: "10px", height: "10px" }
                })
              ]
            ),
            _vm._v(" "),
            _c("label", [
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "/companies/edit/" +
                      _vm.$route.params.id +
                      "?tab=website-details"
                  }
                },
                [_vm._v("Gallery of images "), _c("i", [_vm._v("(optional)")])]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "request-checklist-item" }, [
            _c(
              "span",
              {
                class: {
                  "request-checklist-item-checkbox-active":
                    _vm.checkList.tier_level,
                  "request-checklist-item-checkbox": !_vm.checkList.tier_level
                }
              },
              [
                _c("span", {
                  staticClass: "mod-icon-check",
                  staticStyle: { width: "10px", height: "10px" }
                })
              ]
            ),
            _vm._v(" "),
            _c("label", [
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "/companies/edit/" +
                      _vm.$route.params.id +
                      "?tab=companies-tier"
                  }
                },
                [_vm._v("Tier level selected")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "request-checklist-item rounded-bottom" }, [
            _c(
              "span",
              {
                class: {
                  "request-checklist-item-checkbox-active":
                    _vm.checkList.company_billing,
                  "request-checklist-item-checkbox": !_vm.checkList
                    .company_billing
                }
              },
              [
                _c("span", {
                  staticClass: "mod-icon-check",
                  staticStyle: { width: "10px", height: "10px" }
                })
              ]
            ),
            _vm._v(" "),
            _c("label", [
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "/companies/edit/" +
                      _vm.$route.params.id +
                      "?tab=billing-info"
                  }
                },
                [_vm._v("Billing details entered")]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary btn-request mt-5",
          attrs: { disabled: _vm.isDisabledRequestButton },
          on: {
            click: function($event) {
              _vm.showVisibilityRequestModal = true
            }
          }
        },
        [_vm._v("\n    Request to be visible on Mod24 website\n  ")]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showVisibilityRequestModal
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showVisibilityRequestModal = false
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "sidebar-right flex flex-column justify-content-between pb-0"
                  },
                  [
                    _c("div", { staticClass: "my-auto overflow-y-auto" }, [
                      _c(
                        "div",
                        {
                          staticClass: "pointer",
                          on: {
                            click: function($event) {
                              _vm.showVisibilityRequestModal = !_vm.showVisibilityRequestModal
                            }
                          }
                        },
                        [
                          _c("h1", { staticClass: "modal-h1 l-m-b-20" }, [
                            _c("span", { staticClass: "btn btn-back" }),
                            _vm._v("Mod 24 visibility request")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _c("p", { staticClass: "px-1" }, [
                          _vm._v(
                            "\n              We are glad you considered to use our online services!\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "mt-3 px-1" }, [
                          _vm._v(
                            "\n              Before we proceed with making your company available to the potential customers, we will need to verify information you provided. It might take up to 48h th check and confirm your request.\n            "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "visibility-request-row mt-3" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex w-100 align-items-center justify-content-between"
                            },
                            [
                              _c("div", { staticClass: "w-50 mr-3" }, [
                                _c(
                                  "h5",
                                  {
                                    staticClass:
                                      "visibility-request-section-title"
                                  },
                                  [_vm._v("Your company details")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center justify-content-between mt-3"
                                  },
                                  [
                                    _c("span", { staticClass: "text-dark" }, [
                                      _vm._v("Name")
                                    ]),
                                    _vm._v(" "),
                                    _c("b", { staticClass: "text-blue" }, [
                                      _vm._v(_vm._s(_vm.company.name))
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center justify-content-between mt-3"
                                  },
                                  [
                                    _c("span", { staticClass: "text-dark" }, [
                                      _vm._v("Licence number")
                                    ]),
                                    _vm._v(" "),
                                    _c("b", { staticClass: "text-blue" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.company.licence
                                            ? _vm.company.licence.licence_number
                                            : "/"
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("img", {
                                attrs: {
                                  width: "100",
                                  src: _vm.company.logo
                                    ? _vm.company.logo.url
                                    : "",
                                  alt: "Company logo"
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "visibility-request-row mt-4" },
                        [
                          _c(
                            "h5",
                            { staticClass: "visibility-request-section-title" },
                            [_vm._v("Tier level")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c("div", { staticClass: "tier-level mt-1" }, [
                                _c("h5", { staticClass: "mb-0" }, [
                                  _vm._v(_vm._s(_vm.company.mod_tier.name))
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "tier-percentage" }, [
                                  _vm._v(
                                    _vm._s(_vm.company.mod_tier.percentage) +
                                      "% commission"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "tier-options mb-0" },
                                _vm._l(
                                  _vm.company.mod_tier.mod_tier_options,
                                  function(tier_option) {
                                    return _c("li", { key: tier_option.id }, [
                                      _vm._v(_vm._s(tier_option.name))
                                    ])
                                  }
                                )
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "visibility-request-row mt-3" },
                        [
                          _c(
                            "h5",
                            { staticClass: "visibility-request-section-title" },
                            [_vm._v("Billing details")]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "mt-3 text-sm" }, [
                            _vm._v(
                              "\n              This is account you've selected for your company on bill.com. We will send the invitation to our Mod24 network once we checked your visibility request. Please click the checkbox to confirm you've read and agree to our teams of service.\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _vm.company.company_billing &&
                          parseInt(_vm.company.company_billing.pay_by, 10) !== 0
                            ? _c(
                                "div",
                                { staticClass: "add-billing-options" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "billing-option billing-option-selected"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "billing-details d-flex align-items-center"
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "mod-icon-bill mr-1"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "billing-option-info"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "billing-option-title"
                                                },
                                                [_vm._v("Bill.com")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "billing-option-description"
                                                },
                                                [
                                                  _vm._v(
                                                    "Find your account by using network search or create account"
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass:
                                          "mod-icon-billing-option-checked"
                                      })
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.company.company_billing &&
                          parseInt(_vm.company.company_billing.pay_by, 10) === 0
                            ? _c(
                                "div",
                                { staticClass: "add-billing-options mt-3" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "billing-option billing-option-selected"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "billing-details d-flex align-items-center"
                                        },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "mod-icon-billing-check mr-1"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "billing-option-info"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "billing-option-title"
                                                },
                                                [_vm._v("Check payout")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "billing-option-description"
                                                },
                                                [
                                                  _vm._v(
                                                    "Select to receive payments as checks"
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass:
                                          "mod-icon-billing-option-checked"
                                      })
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "visibility-request-row mt-3" },
                        [
                          _c(
                            "h5",
                            { staticClass: "visibility-request-section-title" },
                            [_vm._v("Service agreement")]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "mt-3 text-sm mb-3" }, [
                            _vm._v(
                              "\n              The agreement is effective from the date when your visibility is approved by Mod24. Copy of this document will be sent to your email.\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "visibility-contract" }, [
                            _c("p", [
                              _c("b", [_vm._v("THIS AGREEMENT")]),
                              _vm._v(" is made on "),
                              _c("span", [_vm._v(_vm._s(_vm.todayDate))]),
                              _vm._v(
                                ", is entered into by and between, the Company and the Service Provider (Company and Service Provider collectively referred to herein as the “Parties” or individually as the “Party”). This Agreement shall become effective (the “Effective Date”) upon the date the visibility request of The Service Provider is approved by The Company.\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("b", [_vm._v("WHEREAS:")])
                            ]),
                            _vm._v(" "),
                            _c("ul", [
                              _c("li", [
                                _vm._v(
                                  "The Service Provider is a skilled and professional provider of logistic support services."
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "The Company operates a web-based business with the purpose of connecting logistic support service providers to potential customers."
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "The Company wishes to make the web-based business platform available to the Service Provider."
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "The Service Provider has indicated and warranted that it has the necessary skills, expertise, personnel and equipment to carry out and complete the Works and to the standards that are stated in this Agreement."
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "The Company now wishes to enter into this Agreement with the Service Provider under which the Service Provider will carry out and complete the Works."
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _c("b", [_vm._v("THEREFORE")]),
                              _vm._v(
                                ", in consideration of mutual promises, representations, covenants and other good and valuable consideration, the receipt and adequacy of which is hereby acknowledged, the Parties agree to the following terms and conditions and to be bound thereby:\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v("DEFINITIONS AND INTERPRETATIONS")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mb-2" }, [
                              _c("b", [_vm._v("In this Agreement")])
                            ]),
                            _vm._v(" "),
                            _c("ul", [
                              _c("li", [
                                _vm._v(
                                  "“Agreement” means this Agreement, its Schedules, Exhibits and other documents (save as may otherwise be varied by this Agreement);"
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "“Works” means providing logistic support services by transporting items from one location to another;"
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                  In this Agreement, unless the context otherwise requires, any reference to:\n                  "
                                ),
                                _c("ul", [
                                  _c("li", [
                                    _vm._v(
                                      "the singular includes the plural and vice versa;"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "a person includes reference to a body corporate or other legal entity;"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "any written law includes that law as amended or re-enacted from time to time;"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "any agreement or other document includes that agreement or other document as varied or replaced by the Parties in writing from time to time;"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "a clause is to the relevant clause of this Agreement;"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "any Party includes that Party’s successors and assigns."
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "Clause headings are inserted for convenience only and shall be ignored in construing this Agreement."
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "The identification of certain breaches in this Agreement as being “Material” does not indicate that only those breaches are material."
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "Where the Agreement provides for the giving or issue of any notice, consent, approval certificate or determination, it shall be in writing and the words notify, certify or determine shall be construed accordingly.  Routine communications relating to the performance of this Agreement may be conducted by electronic mail."
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v(
                                  "APPLICATION OF TERMS AND THE SERVICE PROVIDER UNDERSTANDING"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("ul", [
                              _c("li", [
                                _vm._v(
                                  "Save as may otherwise be provided in this Agreement the terms and conditions set out in this Agreement are the only terms on which the Company is prepared to deal with the Service Provider and they shall govern the relationship between the Parties to the entire exclusion of all other agreements entered into with the Company in relation to the provision of the Works."
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "If any ambiguity is found in the various documents forming this Agreement, the Company shall issue any necessary clarification or instruction."
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "All documents annexed to this agreement shall be subject to the terms under this agreement, provided that the Parties append their signatures on the documents."
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v("COMMENCEMENT AND DURATION")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "This Agreement shall come into force upon execution and shall remain in force until either party terminates this Agreement."
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v("THE OBLIGATIONS OF THE PARTIES")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("ul", [
                              _c("li", [
                                _vm._v(
                                  "The Service Provider will comply with the regulations and policies of the Company as made available in writing or through the Service Provider’s websites and/or software."
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "The Service Provider will supply the Company with all necessary information and documents as may be requested for by the Company for purposes of conducting a due diligence exercise to verify the background and status of the Service Provider."
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "The Service Provider will provide the Company with all necessary consents to enable the Company to conduct a background check on the Service Provider."
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "The Service Provider shall be solely responsible to ensure its assets and personnel are branded with the image and description of the Service Provider."
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "The Company will provide the Service Provider with its own page, containing images and information provided by the Service Provider. The Service Provider’s page will display ratings and reviews regarding the services rendered by the Service Provider. The Service Provider acknowledges and agrees that the Company has no control, directly or indirectly, over the content of the ratings and reviews that may be published on the Service Provider’s page."
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v("PAYMENT AND COMMISSION")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("ul", [
                              _c("li", [
                                _vm._v(
                                  "The Company shall be entitled to a commission of "
                                ),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.company.mod_tier.percentage) +
                                      "%"
                                  )
                                ]),
                                _vm._v(
                                  ", which shall be deducted from each order received and processed via the Company’s platform."
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "All amounts due to the Service Provider shall be paid through either check, or by online payment service via "
                                ),
                                _c(
                                  "a",
                                  { attrs: { href: "https://www.bill.com" } },
                                  [_vm._v("https://www.bill.com")]
                                ),
                                _vm._v(
                                  " on a monthly basis. In the event of any chargebacks by a customer, the Service Provider will be responsible for accrued chargebacks and the Company may, at its sole discretion, deduct chargebacks from the amount due to the Service Provider."
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "The Service Provider shall bear sole responsibility of declaring its earning to the relevant state/federal tax authority. The Service Provider agrees to discharge the Company of any damage, loss or injury arising from the Service Provider’s failure to comply with state/federal tax regulations."
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v("LIABILITY OF THE PARTIES")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("ul", [
                              _c("li", [
                                _vm._v(
                                  "The Service Provider acknowledges and agrees that the Company is in the business of connecting the Service Provider to potential customers and shall not be held liable for any injury, damage or loss occasioned by the Service Provider and/or any potential customer, or any other third-party with whom the Service Provider has entered into a contract with. "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                  The Service Provider acknowledges and agrees that the Company shall not be held liable for any damage where:\n                  "
                                ),
                                _c("ul", [
                                  _c("li", [
                                    _vm._v(
                                      "The damage has been occasioned by the Service Provider, their representatives, employees and/or agents; and"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "The damage has been caused by an event beyond the control of the Service Provider."
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "The Service Provider acknowledges and agrees that the Company shall not be held liable for acts and omissions of the Service Provider, where the same is the subject of a criminal offense;"
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "The service Provider acknowledges and agrees that the Company shall not be held liable for the Service provider’s misuse, abuse or illegal action involving this Agreement, or any other agreement entered into between the Company and the Service Provider."
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "The Company shall be responsible for the performance and maintenance of its Platform and any disputes arising from the operation of such Platform shall be resolved by the Company."
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v("WARRANTIES")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("ul", [
                              _c("li", [
                                _vm._v(
                                  "The Service Provider warrants that it is skilled and competent to perform the works."
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                  The Service Provider warrants that it will perform the Works with due care and diligence and to such high standard of quality consistent with applicable standards and as it is reasonable the Company to expect in all the circumstances;\n                  "
                                ),
                                _c("ul", [
                                  _c("li", [
                                    _vm._v(
                                      "in accordance with the provisions of this Agreement and such other instructions as may be given by the Company; and "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "in accordance with all applicable laws and consents."
                                    )
                                  ])
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v("INDEPENDENT SERVICE PROVIDER")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                The relationship of the parties hereto is that of independent contractors. The parties hereto are not deemed to be agents, partners or joint venturers of the others for any purpose as a result of this Agreement or the transactions contemplated thereby.\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v("NON-COMPETE")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                During the period of this Agreement and for a period of two (2) years following termination of this Agreement for any reason (the “Restricted Period”), Service Provider will not directly or indirectly, on its own behalf, or as a partner, officer, director, trustee, member, employee, or otherwise, within the United States or in any foreign market in which Service Provider was engaged in activities on behalf of the Company or any of its subsidiaries, own, engage in or participate in, in any way, any business that is similar to or competitive with any actual or planned business activity engaged in or planned by the Company or any of its subsidiaries at the time the employment under this Agreement was terminated.\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                During the period of this Agreement and for a period of two (2) years following termination of this Agreement for any reason (the “Restricted Period”), Service Provider will not directly or indirectly, on its own behalf, or as a partner, officer, director, trustee, member, employee, or otherwise attempt in any manner to solicit from any of the Company's clients, except on the Company's behalf, business of the type performed by the Company or to persuade any person, firm or corporation which is a client to cease doing business or to reduce the amount of business which any such client has customarily done or contemplates doing with the Company.\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v("INTELLECTUAL PROPERTY")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                The Service Provider agrees that any ideas, concepts, discoveries, techniques, patents, copyrights or trademarks relating to the business or operations of the Company and its Related Entities which are developed or discovered by the Service Provider, solely or jointly with others, during the subsistence of this Agreement, shall be deemed to have been made within the scope of this Agreement and therefore constitute works for hire and shall automatically upon their creation become the exclusive property of the Company.\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v("DISPUTE RESOLUTION")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                The Parties agree to attempt initially to solve all claims, disputes or controversies arising under, out of or in connection with this Agreement by conducting good faith negotiations. If the Parties are unable to settle the matter between themselves, the matter shall thereafter be resolved by alternative dispute resolution, starting with mediation and including, if necessary, a final and binding arbitration. Whenever a Party shall decide to institute arbitration proceedings, it shall give written notice to that effect to the other Party. The Party giving such notice shall refrain from instituting the arbitration proceedings for a period of sixty (60) days following such notice. During such period, the Parties shall make good faith efforts to amicably resolve the dispute without arbitration.\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v("TERMINATION")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("ul", [
                              _c("li", [
                                _vm._v(
                                  "Either Party shall be entitled to terminate this Agreement immediately upon occurrence if there is suspicion of illegal activity by the other Party involving the Works."
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "Either Party may Terminate this agreement upon giving the other party no less than 30 days’ notice in writing. "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                  The Company may terminate this agreement immediately upon either of the following:\n                  "
                                ),
                                _c("ul", [
                                  _c("li", [
                                    _vm._v(
                                      "The Service Provider fails to deliver the Works within a period equivalent to double the agreed delivery time; or"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "The Service Provider breaches the terms of the Non-Disclosure Agreement."
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                  The termination of this Agreement shall not discharge the liabilities accumulated by either Party.\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                  Any Clauses intended by the Parties or this Agreement to survive the termination of this Agreement shall survive the termination of this Agreement by whatever cause.\n                "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v("VARIATION OF THE AGREEMENT")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                Either party may request variations to the Agreement. The Parties shall enter into discussions to agree on any required changes, revised pricing and time for performance.  Such variations will only be effective if agreed in writing by the Parties and recorded.\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v("FORCE MAJEURE")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("ul", [
                              _c("li", [
                                _vm._v(
                                  "\n                  For the purposes of this Agreement, "
                                ),
                                _c("b", [_vm._v("“Force Majeure”")]),
                                _vm._v(
                                  " means an event which could not reasonably have been avoided by a diligent party in the circumstances, which is beyond the reasonable control of a party and which makes a party’s performance of its responsibilities hereunder impossible or so impractical as reasonably to be considered impossible in the circumstances and includes, but is not limited to, war, riots, civil disorder, earthquake, storm, flood or adverse weather conditions, strikes, lockouts or other industrial action, terrorist acts, confiscation or any other action by government agencies.\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                  Force Majeure shall not include any event which is caused by the negligence or intentional action of a Party or such Party’s subcontractor or agents or employees, or by a failure to observe good professional practice.\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                  Force Majeure shall not include insufficiency of funds or failure to make any payment required hereunder.\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                  The failure of a Party to fulfil any of its obligations hereunder shall not be considered to be a breach of, or default under, this Agreement insofar as such inability arises from an event of Force Majeure, provided that the Party affected by such an event has taken all reasonable precautions, due care and reasonable alternative measures, all with the objective of carrying out the terms of this Agreement.\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                  A Party affected by an event of Force Majeure shall take all reasonable measures to remove such Party’s inability to fulfil its obligations hereunder with a minimum of delay.  The Parties shall take all reasonable measures to minimize the consequence of any event of Force Majeure.\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                  A Party affected by an event of Force Majeure shall notify in writing the other Party of such event as soon as possible, and in any event not later than five (5) days following the occurrence of such event, providing evidence of the nature and cause of such event, and shall similarly give notice of the restoration of normal conditions as soon as possible.\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                  Not later than fourteen (14) days after the Service Provider, as a result of an event of Force Majeure, has become unable to discharge a material portion of its obligations, the Parties shall consult with each other with a view to agreeing on appropriate measures to be taken in the circumstances.\n                "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v("CONFIDENTIALITY")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                Service Provider shall not at any time disclose, directly or indirectly to any other person whatsoever (including to the public or any section of the public) any information concerning this Agreement or any other information of any nature whatsoever concerning the Company, whether such information or matter is stated to be confidential or not, without the express written permission of the Company.  This covenant is given by the Service Provider on its own behalf.\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v("NO WAIVER")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                Except where this Agreement provides otherwise, the rights and remedies contained in it are cumulative and not exclusive to rights or remedies provided by law.  The failure by either Party to enforce at any time or for any period any one or more of the terms or conditions of this Agreement shall not be a waiver of them or of the right at any time subsequently to enforce all terms and conditions of this Agreement.\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v("SEVERABILITY")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                If any provision of this Agreement is declared by any judicial or other competent to be void, voidable, illegal or otherwise unenforceable, the Parties shall amend that provision in such reasonable manner as achieves the intention of the Parties without illegality or at the discretion of the Service Provider, it may be severed from this Agreement and the remaining provisions of this Agreement shall remain in full force and effect.\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v("NOTICES")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                The Parties select as their respective addresses, the addresses (including email) set out below for all purposes arising out of or in connection with this Agreement at which addresses only all processes and notices arising out of or in connection with this Agreement may validly be served upon or delivered by the Parties.\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "pl-3 my-3" }, [
                              _c("p", [_c("b", [_vm._v("THE COMPANY")])]),
                              _vm._v(" "),
                              _c("p", { staticClass: "mt-2" }, [
                                _vm._v("Name: MOD24 LLC")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "mt-2" }, [
                                _vm._v("Email: info@mod24.com")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "mt-2" }, [
                                _vm._v(
                                  "Address: 18580 Ventura blvd B, Tarzana, CA 91356"
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "mt-3 d-inner-block" }, [
                                _c("b", [_vm._v("THE SERVICE PROVIDER")])
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "mt-2" }, [
                                _vm._v("Name: " + _vm._s(_vm.company.name))
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "mt-2" }, [
                                _vm._v("Email: " + _vm._s(_vm.company.email))
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "mt-2" }, [
                                _vm._v(
                                  "Address: " +
                                    _vm._s(_vm.company.address) +
                                    ", " +
                                    _vm._s(_vm.company.city) +
                                    ", " +
                                    _vm._s(_vm.company.state.name) +
                                    ", " +
                                    _vm._s(_vm.company.zip)
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v("CHANGE OF ADDRESS")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                Either Party may provide changes in the above addresses by notice in writing given to the other Party as aforesaid.\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v("COSTS")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                Each party shall bear its own costs incurred in the negotiation, preparation and execution of this Agreement.\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3 mb-2" }, [
                              _c("span", { staticClass: "text-blue" }, [
                                _vm._v("GOVERNING LAW")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                The construction, validity and performance of this Agreement shall be governed in all respects by the Laws of California.\n              "
                              )
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "mt-5" }, [
                        _c("b", [_vm._v("IN WITNESS WHEREOF")]),
                        _vm._v(
                          ", each of the Parties has executed this Service Agreement, both Parties by its duly authorized officer, as of the day and year set forth below.\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-start visibility-signature mt-3"
                        },
                        [
                          _c("div", { staticClass: "w-50 mr-3" }, [
                            _c("p", [
                              _vm._v(
                                "Signed by the duly authorized representative of "
                              ),
                              _c("b", [_vm._v("THE COMPANY")])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-flex mt-3" }, [
                              _c("div", { staticClass: "w-50" }, [
                                _vm._v(
                                  "\n                  Signature:\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "w-50 border-bottom-dashed" },
                                [
                                  _vm._v(
                                    "\n                  S Karimov\n                "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-flex" }, [
                              _c("div", { staticClass: "w-50" }, [
                                _vm._v(
                                  "\n                  Name:\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "w-50 border-bottom-dashed" },
                                [
                                  _vm._v(
                                    "\n                  Suhrab Karimov\n                "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-flex" }, [
                              _c("div", { staticClass: "w-50" }, [
                                _vm._v(
                                  "\n                  Designation:\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "w-50 border-bottom-dashed" },
                                [
                                  _vm._v(
                                    "\n                  Director\n                "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-flex" }, [
                              _c("div", { staticClass: "w-50" }, [
                                _vm._v(
                                  "\n                  Date:\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "w-50 border-bottom-dashed" },
                                [_c("span", [_vm._v(_vm._s(_vm.todayDate))])]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-50 ml-3" }, [
                            _c("p", [
                              _vm._v("Signed by "),
                              _c("b", [_vm._v("SERVICE PROVIDER")])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-flex mt-3" }, [
                              _c("div", { staticClass: "w-50" }, [
                                _vm._v(
                                  "\n                  Signature:\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "w-50 border-bottom-dashed"
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-flex" }, [
                              _c("div", { staticClass: "w-50" }, [
                                _vm._v(
                                  "\n                  Name:\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "w-50 border-bottom-dashed"
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-flex" }, [
                              _c("div", { staticClass: "w-50" }, [
                                _vm._v(
                                  "\n                  Designation:\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "w-50 border-bottom-dashed"
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-flex" }, [
                              _c("div", { staticClass: "w-50" }, [
                                _vm._v(
                                  "\n                  Date:\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "w-50 border-bottom-dashed" },
                                [_c("span", [_vm._v(_vm._s(_vm.todayDate))])]
                              )
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "visibility-request-row mt-3" },
                        [
                          _c(
                            "h5",
                            { staticClass: "visibility-request-section-title" },
                            [_vm._v("Service provider authorized officer")]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "mt-3 text-sm" }, [
                            _vm._v(
                              "\n              Please provide the following details and sign the contract\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-50 select-wrap mt-3" }, [
                            _c("label", [_vm._v("Full name")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.visibilityRequestServiceProvider
                                      .full_name,
                                  expression:
                                    "visibilityRequestServiceProvider.full_name"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text" },
                              domProps: {
                                value:
                                  _vm.visibilityRequestServiceProvider.full_name
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.visibilityRequestServiceProvider,
                                    "full_name",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("error-field", {
                            attrs: { errors: _vm.errors, field: "full_name" }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-50 select-wrap mt-3" }, [
                            _c("label", [_vm._v("Designation")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.visibilityRequestServiceProvider
                                      .designation,
                                  expression:
                                    "visibilityRequestServiceProvider.designation"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text" },
                              domProps: {
                                value:
                                  _vm.visibilityRequestServiceProvider
                                    .designation
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.visibilityRequestServiceProvider,
                                    "designation",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("error-field", {
                            attrs: { errors: _vm.errors, field: "designation" }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "signature-tabs" }, [
                            _c(
                              "div",
                              {
                                staticClass: "signature-tab",
                                class: {
                                  "signature-tab-selected":
                                    _vm.signatureType === 1
                                },
                                on: {
                                  click: function($event) {
                                    _vm.signatureType = 1
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                Draw signature\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "signature-tab",
                                class: {
                                  "signature-tab-selected":
                                    _vm.signatureType === 2
                                },
                                on: {
                                  click: function($event) {
                                    _vm.signatureType = 2
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                Upload signature\n              "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm.signatureType === 1
                            ? [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-center my-4 text-signature"
                                  },
                                  [
                                    _vm._v(
                                      "Use your mouse (or a finger on touch screen devices) to sign this document."
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "card signing-pad-card" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn clear-button",
                                        on: { click: _vm.clear }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-eraser",
                                          attrs: { "aria-hidden": "true" }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "eraser-text" },
                                          [
                                            _vm._v(
                                              "\n                    CLEAR\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex flex-column justify-content-start"
                                      },
                                      [
                                        _c("VueSignaturePad", {
                                          ref: "signaturePad",
                                          attrs: {
                                            width: "100%",
                                            height: "250px",
                                            options: { onEnd: _vm.onEnd }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.signatureType === 2
                            ? [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-center my-4 text-signature"
                                  },
                                  [
                                    _vm._v(
                                      "Select an image file for your signature."
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "card signing-pad-card" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-content-center w-100 p-3"
                                      },
                                      [
                                        _c("input", {
                                          ref: "uploadSignature",
                                          staticClass: "d-none",
                                          attrs: { type: "file" },
                                          on: {
                                            change:
                                              _vm.selectFileForUploadSignature
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "upload-file",
                                            on: {
                                              click: function($event) {
                                                _vm.$refs.uploadSignature.click()
                                              }
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "mod-icon-upload"
                                            }),
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.fileName
                                                    ? _vm.fileName
                                                    : "Browse files"
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("error-field", {
                            attrs: { errors: _vm.errors, field: "signature" }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "terms mb-3" }, [
                            _c(
                              "div",
                              { staticClass: "mt-3 d-flex align-items-center" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.visibilityRequestServiceProvider
                                          .readAndSignedServiceAgreement,
                                      expression:
                                        "visibilityRequestServiceProvider.readAndSignedServiceAgreement"
                                    }
                                  ],
                                  staticClass: "mr-3",
                                  attrs: {
                                    id: "readAndSignedServiceAgreement",
                                    type: "checkbox"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.visibilityRequestServiceProvider
                                        .readAndSignedServiceAgreement
                                    )
                                      ? _vm._i(
                                          _vm.visibilityRequestServiceProvider
                                            .readAndSignedServiceAgreement,
                                          null
                                        ) > -1
                                      : _vm.visibilityRequestServiceProvider
                                          .readAndSignedServiceAgreement
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a =
                                          _vm.visibilityRequestServiceProvider
                                            .readAndSignedServiceAgreement,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.visibilityRequestServiceProvider,
                                              "readAndSignedServiceAgreement",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.visibilityRequestServiceProvider,
                                              "readAndSignedServiceAgreement",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.visibilityRequestServiceProvider,
                                          "readAndSignedServiceAgreement",
                                          $$c
                                        )
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "mb-0",
                                    attrs: {
                                      for: "readAndSignedServiceAgreement"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "I have read and signed the Service Agreement"
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "mt-3 d-flex align-items-center" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.visibilityRequestServiceProvider
                                          .readAndAgreeTermsOfService,
                                      expression:
                                        "visibilityRequestServiceProvider.readAndAgreeTermsOfService"
                                    }
                                  ],
                                  staticClass: "mr-3",
                                  attrs: {
                                    id: "readAndAgreeTermsOfService",
                                    type: "checkbox"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.visibilityRequestServiceProvider
                                        .readAndAgreeTermsOfService
                                    )
                                      ? _vm._i(
                                          _vm.visibilityRequestServiceProvider
                                            .readAndAgreeTermsOfService,
                                          null
                                        ) > -1
                                      : _vm.visibilityRequestServiceProvider
                                          .readAndAgreeTermsOfService
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a =
                                          _vm.visibilityRequestServiceProvider
                                            .readAndAgreeTermsOfService,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.visibilityRequestServiceProvider,
                                              "readAndAgreeTermsOfService",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.visibilityRequestServiceProvider,
                                              "readAndAgreeTermsOfService",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.visibilityRequestServiceProvider,
                                          "readAndAgreeTermsOfService",
                                          $$c
                                        )
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "mb-0",
                                    attrs: { for: "readAndAgreeTermsOfService" }
                                  },
                                  [
                                    _vm._v("I have read and agree to the "),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          target: "_blank",
                                          href:
                                            _vm.webSiteUrl +
                                            "/terms-and-conditions"
                                        }
                                      },
                                      [_vm._v("Terms of Service")]
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "mt-3 top-shadow p-3 fix-width-bottom-bar"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex w-100 align-items-center justify-content-end"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-not-active text-dark",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    _vm.showVisibilityRequestModal = false
                                  }
                                }
                              },
                              [_vm._v("\n              Cancel\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary ml-3",
                                attrs: {
                                  disabled:
                                    !_vm.visibilityRequestServiceProvider
                                      .readAndSignedServiceAgreement ||
                                    !_vm.visibilityRequestServiceProvider
                                      .readAndAgreeTermsOfService
                                },
                                on: {
                                  click: _vm.openVisibilitySendRequestModal
                                }
                              },
                              [_vm._v("\n              Submit\n            ")]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.showSendVisibilityRequest
        ? _c(
            "modal",
            {
              attrs: { container: "l-modal-container-sm" },
              on: {
                close: function($event) {
                  _vm.showSendVisibilityRequest = false
                }
              }
            },
            [
              _c("template", { slot: "header" }, [_vm._v(" ")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column align-items-center px-3",
                  attrs: { slot: "body" },
                  slot: "body"
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../../../assets/img/submit-request.svg"),
                      alt: "Tier select"
                    }
                  }),
                  _vm._v(" "),
                  _c("h4", { staticClass: "text-center mt-4" }, [
                    _vm._v(
                      "You're about to submit a request to be visible on Mod24 website!"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-center mt-3 px-3" }, [
                    _vm._v(
                      "\n        Our team will verify your information within the next 48h. A reply will be sent to your company email address.\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-center mt-3 px-3" }, [
                    _vm._v(
                      "\n        If you need to change any information, such as images, description, logo, licence number or payments details, it will need additional approval from our team.\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "licence_number" }
                  }),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "note" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-center w-100 mt-3"
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-secondary mr-1 w-50 btn-decline",
                          on: {
                            click: function($event) {
                              _vm.showSendVisibilityRequest = false
                            }
                          }
                        },
                        [_vm._v("\n          No, go back.\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary ml-1 w-50 btn-accept",
                          on: { click: _vm.requestVisibilityCompany }
                        },
                        [_vm._v("\n          Yes, submit.\n        ")]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("template", { slot: "footer" }, [_vm._v(" ")])
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-3 w-100" }, [
      _c("h5", { staticClass: "companies-sub-page-title" }, [
        _vm._v("Getting started")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mod-24-settings" }, [
        _c("p", [_vm._v("In Mod24 settings section you can adjust: ")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("b", [_vm._v("Website details")]),
            _vm._v(
              " - Information that will be publicly available for potential customers, such as your logo, description, photos, etc."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("b", [_vm._v("Tier level")]),
            _vm._v(
              " - Type of subscription and it's options, related to being visible as a company on Mod24 website"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("b", [_vm._v("Billing info")]),
            _vm._v(
              " - Choosing how you want to receive what you've earned from online bookings"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("b", [_vm._v("Company licence")]),
            _vm._v(" - Entering a valid company licence")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f7ab608", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f7ab608","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/mod24settings/CompaniesGettingStarted.vue
// module id = null
// module chunks = 